import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { BackendService } from '../../services/backend/backend.service';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { EnquiryHeaderItem } from '../../models/data/enquiry.model';
import { OpenItdcrEvent } from '../../models/app/openItdcr.model';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-modal-price-options',
  templateUrl: './modal-price-options.component.html',
  styleUrls: ['./modal-price-options.component.scss']
})
export class ModalPriceOptionsComponent implements OnInit, OnChanges {
  @Input() enquiryNo: string = "";
  @Input() itemNo: string = "";
  @Input() item?: EnquiryHeaderItem;
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() origin: string = '';
  @Input() readOnly: boolean = true;
  @Input() rawMaterialGrade: string | null = null;
  @Input() modalPriceOpenAs: string = "";
  @Input() costsSourceCostingToolRecordId: number | null = null;
  @Input() costsSourceCostingToolVersionId: number | null = null;
  @Input() costsSourceDescription: string = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ";

  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onOpenITDCR: EventEmitter<OpenItdcrEvent> = new EventEmitter();
  @Output() onOpenCostingTool: EventEmitter<{
    useNearestMatch?: boolean;
    origin?: string;
    costsSourceCostingToolRecordId?: number | null;
    costsSourceCostingToolVersionId?: number | null;
  }> = new EventEmitter();

  showSelectCostFromCrModal: boolean = false;
  crFullCostValue: number | null = null;
  crAlloySurchargeValue: number | null = null;
  showItdcrViewerModal: boolean = false;
  selectedItdcrNo: string = '';




  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService,
    private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
    }

    if (changes && changes["itemNo"]) {
      this.itemNo = changes["itemNo"].currentValue;
    }

    if (changes && changes["item"]) {
      this.item = changes["item"].currentValue;
    }

    if (changes && changes["isMobile"]) {
      this.isMobile = changes["isMobile"].currentValue;
    }

    if (changes && changes["theme"]) {
      this.theme = changes["theme"].currentValue;
    }

    if (changes && changes["origin"]) {
      this.origin = changes["origin"].currentValue;
    }

    if (changes && changes["rawMaterialGrade"]) {
      this.rawMaterialGrade = changes["rawMaterialGrade"].currentValue;
    }

    if (changes && changes["modalPriceOpenAs"]) {
      this.modalPriceOpenAs = changes["modalPriceOpenAs"].currentValue;
    }

    if (changes && changes["costsSourceCostingToolRecordId"]) {
      this.costsSourceCostingToolRecordId = changes["costsSourceCostingToolRecordId"].currentValue;
    }

    if (changes && changes["costsSourceCostingToolVersionId"]) {
      this.costsSourceCostingToolVersionId = changes["costsSourceCostingToolVersionId"].currentValue;
    }

    if (changes && changes["costsSourceDescription"]) {
      this.costsSourceDescription = changes["costsSourceDescription"].currentValue;
    }
  }

  recomputeCost() {
    this.teiasoftLoader.start();
    this.backendService.recomputeCost(this.enquiryNo, this.itemNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.onCancel.emit('refresh');
    });
  }

  isRawMaterialDefined(item: EnquiryHeaderItem | undefined): boolean {
    return !!item?.['rawMaterialGrade.rawMaterialGradeId'] && item?.['rawMaterialGrade.isDummy'] !== true;
  }

  /* EVENTS */
  onCancelClick() {
    this.onCancel.emit('');
  }

  onSearchInCostingToolClick() {
    this.onOpenCostingTool.emit({ useNearestMatch: false });
  }

  onOpenNewITR() {

  }

  onNavigateToCostingTool() {
    this.onOpenCostingTool.emit({
      useNearestMatch: false,
      origin: 'record-id',
      costsSourceCostingToolVersionId: this.costsSourceCostingToolVersionId,
      costsSourceCostingToolRecordId: this.costsSourceCostingToolRecordId
    });
  }

  onRecomputeClick() {
    this.recomputeCost();
  }

  // onSelectFromCostingTool() {
  //   this.modalPriceOpenAs = 'ctTool-Ictdr';
  // }


  onSearchNearestInCostingToolClick() {
    this.onOpenCostingTool.emit({
      useNearestMatch: true,
      origin: this.origin,
      costsSourceCostingToolVersionId: this.costsSourceCostingToolVersionId,
      costsSourceCostingToolRecordId: this.costsSourceCostingToolRecordId
    });
  }

  onSelectCostFromCrClick() {
    this.setCrInitialValues();
    this.showSelectCostFromCrModal = true;
  }

  onSaveCostFromCr(payload: { fullCost: number; alloySurchargeValue: number | null }) {
    const asValue = this.shouldRequestAlloySurcharge() ? (payload.alloySurchargeValue ?? 0) : null;
    this.teiasoftLoader.start();
    this.backendService.setItemCost(this.enquiryNo, this.itemNo, payload.fullCost, asValue).subscribe({
      next: () => {
        this.teiasoftLoader.stop();
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
        this.showSelectCostFromCrModal = false;
        this.onCancel.emit('refresh');
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    });
  }

  onCancelSelectCostFromCr() {
    this.showSelectCostFromCrModal = false;
  }

  onOpenITDCRClick() {
    this.onOpenITDCR.emit(
      {
        enquiryNo: this.enquiryNo,
        itemNo: this.item?.itemNo!,
        sourceEvent: 'P'
      });
  }

  get showItdcrHistoryLink(): boolean {
    const source = String(this.item?.['costsSource'] ?? '').trim().toLowerCase();
    return source === 'itdcr' || source === 'itr';
  }

  onNavigateToItdcrHistory() {
    if (!this.enquiryNo || !this.itemNo || !this.showItdcrHistoryLink) return;

    this.teiasoftLoader.start();
    this.backendService.getItdcrNumberByItemAndCategory(this.enquiryNo, this.itemNo, 'P')
      .pipe(finalize(() => this.teiasoftLoader.stop()))
      .subscribe(res => {
        const itdcrNo = res?.itdcrNo?.trim?.() || '';
        if (!itdcrNo) {
          this.teiasoftToaster.show("info", this.translate.instant("itdcr.notAvailableForItem"));
          return;
        }

        this.selectedItdcrNo = itdcrNo;
        this.showItdcrViewerModal = true;
      });
  }

  onCloseItdcrViewer() {
    this.showItdcrViewerModal = false;
    this.selectedItdcrNo = '';
  }

  private setCrInitialValues() {
    const isExternalCr = (this.item as any)?.costsSource === 'ExternalCr';
    this.crFullCostValue = isExternalCr ? this.toNumberOrNull((this.item as any)?.fullCost) : null;
    this.crAlloySurchargeValue = (this.shouldRequestAlloySurcharge() && isExternalCr) ? this.toNumberOrNull((this.item as any)?.alloySurchargeValue) : null;
  }

  private shouldRequestAlloySurcharge(): boolean {
    return this.item?.alloySurcharge === false;
  }

  private toNumberOrNull(value: any): number | null {
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
}
